<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'time-off-v3.selectADateOrDateRange' | translate }}</mat-label>
            <input
                class="d-none"
                name="date"
                #blackoutPeriodStartDate="ngModel"
                required
                [(ngModel)]="timeOffRequestBlackoutPeriod.startDate"
                matInput
                type="text"
            />
            <mat-error *ngIf="blackoutPeriodStartDate.invalid && blackoutPeriodStartDate.touched">{{
                blackoutPeriodStartDate.errors | formErrors
            }}</mat-error>
            <ui-inline-date-picker
                #calendar
                (dateRangesChange)="setDateRange($event)"
                [startDate]="timeOffRequestBlackoutPeriod.startDate"
                [endDate]="timeOffRequestBlackoutPeriod.endDate"
            ></ui-inline-date-picker>
        </mat-form-field>
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'time-off-v3.blackoutPeriodName' | translate }}</mat-label>
            <input
                name="name"
                #blackoutPeriodName="ngModel"
                placeholder="{{ 'time-off-v3.egTaxSeason' | translate }}"
                required
                [(ngModel)]="timeOffRequestBlackoutPeriod.name"
                matInput
                type="text"
            />
            <mat-error *ngIf="blackoutPeriodName.invalid && blackoutPeriodName.touched">{{
                blackoutPeriodName.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </div>
</form>
